/* eslint-disable */
import moment from 'moment';
function log(...message) {
    // // console.log(...message);
}
function debug(...message) {
    // // console.log(...message);
}
const info = (message) => {
    // // console.log(`%c ${timestamp()} ${message} `, 'color: blue');
};
const warn = (message) => {
    // // console.log(`%c ${timestamp()} ${message} `, 'color: orange');
};
const error = (message, stacktrace) => {
    // // console.log(`%c ${timestamp()} ${message} `, 'color: red');
    console.trace();
    if (process.env.DEBUG_LOG && stacktrace) {
        // // console.log(stacktrace);
    }
};
function timestamp() {
    return `[${moment().format('L') + ' ' + moment().format('HH:mm:ss')}]`;
}
const Logger = { log, info, warn, error, debug };
export default Logger;
